import {
  ActionList,
  ActionListProps,
  Button,
  PopoverProps,
} from "@shopify/polaris"
import { MenuHorizontalIcon } from "@shopify/polaris-icons"
import { useRef } from "react"

import { ProPopover, ProPopoverProps } from "./ProPopover"

export interface ProPopoverWithItemsProps extends Omit<
  ProPopoverProps,
  "activator" | "children"
> {
  items: ActionListProps["items"]
  preferredAlignment?: PopoverProps["preferredAlignment"]
  activator?: ProPopoverProps["activator"]
  children?: ProPopoverProps["children"]
}
export const ProPopoverWithItems = (props: ProPopoverWithItemsProps) => {
  const { activator, items, preferredAlignment = "left", onShowChange } = props
  const ref = useRef<any>()
  return (
    <ProPopover
      activator={
        activator || (
          <Button
            variant="tertiary"
            // size="micro"
            icon={MenuHorizontalIcon}
          ></Button>
        )
      }
      ref={ref}
      preferredAlignment={preferredAlignment}
      onShowChange={onShowChange}
    >
      <ActionList
        items={items?.map((item) => {
          return {
            ...item,
            onAction() {
              item.onAction?.()
              ref.current?.setShow(false)
            },
          }
        })}
      />
    </ProPopover>
  )
}
